import {
  AI_IMAGES_REQUEST,
  AI_IMAGES_SUCCESS,
  AI_IMAGES_FAILURE,
} from "../types/aiImages.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const AiImagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_IMAGES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AI_IMAGES_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case AI_IMAGES_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default AiImagesReducer;
